import { useTranslation } from 'react-i18next'
import { useCustomer } from 'hooks/useSession'
import TextPaper from '@ui/elements/TextPaper'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import { hasTextPaperLines } from '@user/customer/confirmation/getTextPaperStatus'

interface Props {
  onPress: () => void
}

export default function AddressDetails({ onPress }: Props) {
  const { t } = useTranslation(['ui', 'modals'])

  const customer = useCustomer()
  const { needsAddress, needsVat, getDetailStatus } = useConfirmCustomer()
  const { street, street2, zip, city, country_code, vat } =
    customer?.address || {}
  const config = useRemoteConfig()

  const country_name = country_code
    ? t(`countries:${country_code.toLowerCase()}`)
    : undefined

  const lines = [
    [street, street2].filter(Boolean).join(' '),
    [zip, city].filter(Boolean).join(' '),
    [country_name, country_code].filter(Boolean).join(' '),
    config?.region.vat !== 'hidden' ? vat : undefined,
  ]

  const status = getDetailStatus({
    hasData: hasTextPaperLines(lines),
    isValid: !needsAddress && !needsVat,
    section: 'address',
  })

  return (
    <TextPaper
      onPress={onPress}
      icon="home-2"
      label={t('modals:address.title')}
      lines={lines}
      status={status}
    />
  )
}
